import { useNavigate } from 'react-router-dom'
import { Card, CardContent } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { useFarmId } from '~/common/use-farm-id'
import CropScheduleTimeline from './crop-timeline'
import { TpFullscreenFab } from '~/components/tp-fullscreen-fab'
import { EditCropContextProvider } from '~/crop/edit-crop/edit-crop-context-provider'
import { useEditCropContext } from '~/crop/edit-crop/edit-crop-context'
import { useFeatures } from '~/common/use-features'
import { useState } from 'react'

const CropScheduleCardContent = () => {
  const navigate = useNavigate()
  const { farmId } = useFarmId()
  const { onPhaseAdjust, onTaskAdjust } = useEditCropContext()
  const { features } = useFeatures()
  const [isMouseOver, setIsMouseOver] = useState(false)

  const handleFullscreen = () => {
    const url = farmId ? `/timeline?farmId=${farmId}` : '/timeline'
    navigate(url)
  }

  return (
    <Card
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}
    >
      <CardContent
        sx={{
          p: 0,
          flex: 1,
          overflow: 'auto',
          minHeight: 0,
          '&.MuiCardContent-root:last-child': {
            pb: 0,
          }
        }}
      >
        <CropScheduleTimeline
          onPhaseAdjust={onPhaseAdjust}
          onTaskAdjust={onTaskAdjust}
        />
      </CardContent>

      {features['page_timeline'] && isMouseOver && (
        <TpFullscreenFab onClick={handleFullscreen}>
          <Icons.Fullscreen />
        </TpFullscreenFab>
      )}
    </Card>
  )
}

export const CropScheduleCard = () => (
  <EditCropContextProvider>
    <CropScheduleCardContent />
  </EditCropContextProvider>
)
